import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, CardActions, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Article from '../../../domain/entities/Article'; // Assuming Article entity is passed directly

const ArticleCard = ({ article, onDelete, onEdit }) => {
  const navigate = useNavigate();

  if (!(article instanceof Article)) {
    console.error("ArticleCard expects an Article entity instance.");
    return null;
  }

  const handleViewDetails = () => {
    navigate(`/articles/${article.id}`);
  };

  const handleEdit = () => {
    onEdit(article.id);
  };

  const handleDelete = () => {
    onDelete(article.id);
  };

  return (
    <Card sx={{ maxWidth: 800, margin: '20px auto', boxShadow: 3, borderRadius: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
      {article.imageUrl && (
        <CardMedia
          component="img"
          sx={{ width: { xs: '100%', sm: 200 }, height: { xs: 200, sm: 'auto' }, flexShrink: 0, objectFit: 'cover' }}
          image={article.imageUrl}
          alt={article.title}
        />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="h6" component="div" gutterBottom>
            {article.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {article.category} | {new Date(article.createdAt).toLocaleDateString()}
          </Typography>
          <Typography variant="body2" color="text.primary" sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
          }}>
            {article.description}
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
          <Button size="small" onClick={handleViewDetails}>Read More</Button>
          {onEdit && (
            <Button size="small" color="primary" onClick={handleEdit}>Edit</Button>
          )}
          {onDelete && (
            <Button size="small" color="error" onClick={handleDelete}>Delete</Button>
          )}
        </CardActions>
      </Box>
    </Card>
  );
};

export default ArticleCard;
